import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreKeyEditComponent } from './store-key-edit/store-key-edit.component';
import { StoreKeyCreateComponent } from './store-key-create/store-key-create.component';
import { StoreKeyFormComponent } from './store-key-form/store-key-form.component';
import { StoreKeyIndexComponent } from './store-key-index/store-key-index.component';
import {StoreKeyComponent} from './store-key.component';
import {CardModule} from '../../resources/components/card/card.module';
import {SmartTableModule} from '../../resources/modules/smart-table/smart-table.module';
import {MomentPipeModule} from '../../resources/pipes/moment-pipe/moment-pipe.module';
import {BadgeExistModule} from '../../resources/components/badge-exist/badge-exist.module';
import {IconsModule} from '../../resources/components/icons/icons.module';
import {ReducerPipeModule} from '../../resources/pipes/reducer-pipe/reducer-pipe.module';
import {NgxPopperModule} from 'ngx-popper';
import {PaginationModule} from '../../resources/components/pagination/pagination.module';
import {PreloaderModule} from '../../resources/components/preloader/preloader.module';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../resources/modules/form-group-context/form-group-simple/form-group-simple.module';
import {ValidateModule} from '../../resources/modules/validate/validate.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {StoreKeyRoutesModule} from './store-key-routes/store-key-routes.module';
import {EntityLinkModule} from '../../resources/components/entity-link/entity-link.module';
import {BtnDeleteModule} from "../../resources/components/btn-delete/btn-delete.module";
import {TableStoreKeyModule} from "../../resources/tables/table-store-key/table-store-key.module";



@NgModule({
  declarations: [
    StoreKeyComponent,
    StoreKeyEditComponent,
    StoreKeyCreateComponent,
    StoreKeyFormComponent,
    StoreKeyIndexComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    StoreKeyRoutesModule,
    SmartTableModule,
    MomentPipeModule,
    BadgeExistModule,
    IconsModule,
    ReducerPipeModule,
    NgxPopperModule,
    PaginationModule,
    PreloaderModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    FormsModule,
    ReactiveFormsModule,
    EntityLinkModule,
    BtnDeleteModule,
    TableStoreKeyModule
  ]
})
export class StoreKeyModule { }
